<template>
  <div class="merchant-profile">
    <div class="edit-merchant" :class="{ editEnable: editMerchant }">
      <v-row no-gutters>
        <v-col cols="12" md="12" class="pa-0">
          <div class="card card-custom card-compact sub-card">
            <div class="card-header card-header-nobdr pt-0 pl-0 pr-0">
              <div class="card-title">
                <h3 class="card-label">Merchant</h3>
                <span class="sub-title"
                  >Please click the edit button on right to edit merchant</span
                >
              </div>
              <div class="header-aside-content">
                <!-- <div class="aside-btn">
                  <v-btn
                    color="primary"
                    @click="editMerchantInfo"
                    height="38"
                    width="100"
                  >
                    <v-icon left dark> mdi-account-edit </v-icon>
                    Edit</v-btn
                  >
                </div> -->
              </div>
            </div>
            <div class="card-body pt-5">
              <v-row>
                <v-col cols="12" md="4">
                  <div class="merchant-logo-wrap">
                    <div class="card-content-header">
                      <v-toolbar color="white" flat class="content-toolbar">
                        <v-toolbar-title class="grey--text text--darken-4">
                          Merchant Logo
                        </v-toolbar-title>

                        <v-spacer></v-spacer>
                      </v-toolbar>
                    </div>
                    <div class="profile-image-upload">
                      <div class="uploaded-file">
                        
                        <img :src="merchantLogo" v-if="previewImage === null" alt="" class="merchant-logo" />
                        <img :src="previewImage"  v-else alt="" class="preview-logo"/>
                      </div>
                      <div class="uploader">
                        <v-file-input
                          accept="image/*"
                          label="Upload Logo"
                          @change="uploadLogo($event)"
                        ></v-file-input>
                      </div>
                      <div class="upload-btn">
                        <v-btn
                          small
                          color="primary"
                          :loading="uploadLoading"
                          v-if="selectedImage !== null"
                          @click="postLogo"
                          >Upload</v-btn
                        >
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="8">
                  <div class="profile-info-wrapper">
                      <v-toolbar color="white" flat class="content-toolbar mb-6">
                        <v-toolbar-title class="grey--text text--darken-4">
                          Merchant Information
                        </v-toolbar-title>

                        <v-spacer></v-spacer>

                        <v-btn
                          color="primary"
                          @click="editMerchantInfo"
                          height="38"
                          width="130"
                        >
                          <v-icon left dark color="white">
                            mdi-account-edit
                          </v-icon>
                          Edit Info</v-btn
                        >
                      </v-toolbar>
                      <v-row no-gutters>
                        <v-col cols="12" md="6" class="pt-0 pb-0">
                          <ul class="merchant-detail-list">
                            <li>
                              <!-- <div class="list-title">
                                Company Name
                              </div> -->
                              <div class="list-info">
                                <v-text-field
                                  label="Company Name"                                 
                                  placeholder="Placeholder"
                                  v-model="merchantDetail.companyName"
                                ></v-text-field>
                              </div>
                            </li>
                            <li>
                              <!-- <div class="list-title">
                                Company Url
                              </div> -->
                              <div class="list-info">
                                <v-text-field
                                  label="Company Url"
                                  placeholder="Placeholder"
                                  v-model="merchantDetail.companyUrl"
                                ></v-text-field>
                              </div>
                            </li>
                            <li>
                              <!-- <div class="list-title">
                                Organization ID
                              </div> -->
                              <div class="list-info">
                                <v-text-field
                                  label="Organization ID"
                                  placeholder="Organization ID"
                                  v-model="merchantDetail.organizationId"
                                ></v-text-field>
                              </div>
                            </li>

                            <li>
                              <!-- <div class="list-title">
                                Profile Name
                              </div> -->
                              <div class="list-info">
                                <v-text-field
                                  label="Profile Name"
                                  placeholder="Profile Name"
                                  v-model="merchantDetail.profileName"
                                ></v-text-field>
                              </div>
                            </li>
                          </ul>
                        </v-col>
                        <v-col cols="12" md="6" class="pt-0 pb-0">
                          <ul class="merchant-detail-list">
                            <li>
                              <!-- <div class="list-title">
                                Contact Person
                              </div> -->
                              <div class="list-info">
                                <v-text-field
                                  label="Contact Person"
                                  placeholder="Contact Person"
                                  v-model="merchantDetail.contactPerson"
                                ></v-text-field>
                              </div>
                            </li>
                            <li>
                              
                              <div class="list-info">
                                <v-text-field
                                  label="Notification Email"
                                  placeholder="Notification Email"
                                  v-model="merchantDetail.notificationEmail"
                                ></v-text-field>
                              </div>
                            </li>
                            <li>
                              
                              <div class="list-info">
                                <v-text-field
                                  label="Notification Mobile Number"
                                  placeholder="Notification Mobile Number"
                                  v-model="merchantDetail.notificationMobileNumber"
                                ></v-text-field>
                              </div>
                            </li>
                            <li>
                              
                              <div class="list-info">
                                <v-text-field
                                  label="Profile Description"
                                  placeholder="Profile Description"
                                  v-model="merchantDetail.profileDescription"
                                ></v-text-field>
                              </div>
                            </li>
                          </ul>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-btn
                            width="160"
                            height="48"
                            outlined
                            class="ml-3"
                            color="grey"
                            v-if="editMerchant"
                            @click.prevent="cancelUpdateMerchant"
                          >
                            cancel
                          </v-btn>
                          <v-btn
                            width="160"
                            height="48"
                            class="ml-3"
                            color="primary"
                            v-if="editMerchant"
                            @click.prevent="updateMerchant"
                          >
                            Update
                            <v-icon right dark> mdi-chevron-right </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import Promise from "../../../../../lib/mixins/ExtendedPromises";
import Merchant from "../../../../../repositories/adminMerchantController";
export default {
  name: "MerchantProfile",
  mixins: [Promise],
  data() {
    return {
      merchantID: "",
      merchantDetail: {},
      editMerchant: false,
      previewImage: null,
      selectedImage: null,
      merchantLogo: null,
      uploadLoading: false
    };
  },
  beforeMount() {
    this.merchantID = this.$route.params.id;
  },
  mounted() {
    this.getMerchantDetail();
    this.getMerchantLogo();
  },

  methods: {
    getMerchantLogo() {
      const operation = this.response(Merchant.getMerchantLogo(this.merchantID));
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.merchantLogo = response.data;
          }
        })
        .catch(err => {
          this.$toasted.show(err.data.message, {
            type: "error"
          });
        });
    },
    uploadLogo(event) {
      if (event !== undefined) {
        this.selectedImage = event;
        this.createImage(event);
      } else {
        this.selectedImage = null;
        this.previewImage = null;
      }
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = e => {
        vm.previewImage = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    postLogo() {      
      let formData = new FormData();
      formData.append("files", this.selectedImage);
      this.uploadLoading = true;
      const operation = this.response(
        Merchant.uploadMerchantLogo(this.merchantID, formData)
      );
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.$toasted.show(response.data.message);
            this.previewImage = null;
            this.selectedImage = null;
             this.uploadLoading = false;
            this.getMerchantLogo();
           
          }
        })
        .catch(err => {
          this.uploadLoading = false;
          this.$toasted.show(err.data.message, {
            type: "error"
          });
        });
    },
    getMerchantDetail() {
      const operation = this.response(
        Merchant.getMerchantDetail(this.merchantID)
      );
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.merchantDetail = response.data;
            this.merchantID = this.merchantID ?? response.data.merchantId
          }
        })
        .catch(err => {
          this.$toasted.show(err.data.message, {
            type: "error"
          });
        });
    },
    editMerchantInfo() {
      this.editMerchant = true;
    },
    cancelUpdateMerchant() {
      this.editMerchant = false;
    },
    updateMerchant() {
      const operation = this.response(
        Merchant.updateMerchant(this.merchantDetail, this.merchantID)
      );
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.$toasted.show("Merchant Updated Successfully");
            this.getMerchantDetail();
            this.editMerchant = false;
          }
        })
        .catch(err => {
          this.$toasted.show(err.data.message, {
            type: "error"
          });
          this.editMerchant = false;
        });
    }
  }
};
</script>
